<div
  class="bg-white border border-gray-200 hover:border-transparent rounded-2xl overflow-hidden max-w-[400px] h-full flex flex-col transition-all duration-300"
>
  <!-- Image -->
  <div class="overflow-hidden bg-gray-50 aspect-square w-full">
    <img
      [src]="imageSrc || '/placeholder.svg'"
      (error)="onImageError($event)"
      [routerLink]="['/products', id]"
      alt="{{ title }}"
      class="w-full h-full aspect-square object-cover cursor-pointer transition-transform duration-500 ease-in-out hover:scale-105"
    />
  </div>

  <!-- Content -->
  <div class="p-5 flex flex-col gap-2.5 flex-grow">
    <!-- Title -->
    <h2 class="text-base font-bold text-gray-900 leading-snug line-clamp-2">
      {{ title.length > 40 ? (title | slice: 0 : 40) + "..." : title }}
    </h2>

    <!-- Price -->
    <div class="flex items-center gap-2">
      <span class="text-xl font-extrabold text-[var(--primary)]">
        Rs. {{ price.toFixed(2) }}
      </span>

      @if (oldPrice) {
        <span class="text-xs text-gray-400 line-through">
          Rs. {{ oldPrice.toFixed(2) }}
        </span>
      }
    </div>

    <!-- Stock Status -->
    <div class="flex items-center gap-2">
      @if (getTotalStock() > 0) {
        <span
          class="text-xs font-semibold text-emerald-600 bg-emerald-50 px-2.5 py-1 rounded-full border border-emerald-200"
        >
          In Stock ({{ getTotalStock() }})
        </span>
      } @else {
        <span
          class="text-xs font-semibold text-rose-600 bg-rose-50 px-2.5 py-1 rounded-full border border-rose-200"
        >
          Out of Stock
        </span>
      }
    </div>

    <!-- Buttons -->
    <div class="mt-auto pt-3 flex gap-2 justify-between">
      <!-- Buy Now -->
      <button
        [routerLink]="['/products', id]"
        [disabled]="getTotalStock() === 0"
        class="flex-1 flex cursor-pointer font-bold text-sm justify-center items-center gap-1.5 bg-[var(--primary)] text-white py-2.5 rounded-xl hover:bg-gray-900 transition-colors border border-[var(--primary)] disabled:bg-gray-300 disabled:border-gray-300 disabled:text-gray-500 disabled:cursor-not-allowed"
      >
        <fa-icon [icon]="faBolt" class="w-4 h-4"></fa-icon>
        Buy Now
      </button>

      <!-- Add to Cart -->
      <button
        (click)="addToCart()"
        [disabled]="addToCartLoading || getTotalStock() === 0"
        title="Add to Cart"
        class="group flex cursor-pointer items-center justify-center gap-1.5 border border-gray-300 text-gray-700 px-3 py-2.5 rounded-xl hover:bg-[var(--primary)] hover:text-white hover:border-[var(--primary)] transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
      >
        @if (addToCartLoading) {
          <app-items-loading
            size="w-4 h-4"
            class="group-hover:[&>svg>circle]:stroke-white group-hover:[&>svg>path]:fill-white"
          ></app-items-loading>
        } @else {
          <fa-icon [icon]="faCartPlus" class="w-4 h-4"></fa-icon>
        }
      </button>

      <!-- Add to Gift Box -->
      <!-- <button
        (click)="addToGiftBox()"
        [disabled]="getTotalStock() === 0"
        title="Pack into Gift Box"
        class="group flex cursor-pointer items-center justify-center gap-1.5 
               border border-amber-300 text-amber-700 bg-amber-50
               px-3 py-2.5 rounded-xl 
               hover:bg-amber-500 hover:text-white hover:border-amber-500 transition-colors 
               disabled:opacity-50 disabled:cursor-not-allowed"
      >
        <fa-icon [icon]="faBoxOpen" class="w-4 h-4"></fa-icon>
      </button> -->
    </div>
  </div>
</div>
